import { render, staticRenderFns } from "./ShokurekishoWithImageEdit.vue?vue&type=template&id=15ed2199&scoped=true"
import script from "./ShokurekishoWithImageEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoWithImageEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoWithImageEdit.vue?vue&type=style&index=0&id=15ed2199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed2199",
  null
  
)

export default component.exports